import { sum } from '@shared/lib/money';
import { ResultsState } from '../reducers';
import { createSelector } from 'reselect';
import { Money } from '../../../types';
import { SelectedFare } from '../../../DesktopFlight/types';
import memes from '../../../memes';

export const getSelectedFares = (state: ResultsState) => state.selectedFares;

const memoizedSum = memes(sum);

export const getTotalPrice = createSelector(
	[getSelectedFares],
	(selectedFares: SelectedFare[]): Money => {
		const lastSelectedFare = selectedFares[selectedFares.length - 1];
		const flightId = lastSelectedFare?.flightInfo.id;

		const money = selectedFares.map(({ prices }) => prices.find(price => price.flight.id === flightId).price);

		return memoizedSum(...money);
	}
);

export const getCreateOrderUrl = createSelector([getSelectedFares], (selectedFares: SelectedFare[]): string => {
	return `#/results/create-order/${selectedFares.map(selectedFare => selectedFare.flightInfo.id).join('/')}`;
});
